import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import React, { useContext } from 'react';
import { ThemeContext } from '../ThemeContext/ThemeContext';

const ConfirmationModal = ({ title, isOpen, handleClose, handleAction }) => {
  const { theme } = useContext(ThemeContext);

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: theme.palette.background.default,
          borderRadius: '15px',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
        }
      }}
    >
      <DialogTitle sx={{ color: theme.palette.text.secondary }}>Confirme sua ação</DialogTitle>
      <DialogActions sx={{ justifyContent: 'space-between', margin: '1rem 0' }}>
        <Button
          sx={{
            color: theme => theme.palette.error.main,
            borderRadius: '10px',
            textTransform: 'capitalize'
          }}
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          sx={{
            borderRadius: '10px',
            textTransform: 'capitalize'
          }}
          onClick={handleAction}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;